import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LayoutTemplate, Pencil, Trash2, Copy, BookmarkPlus } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function TemplatesButton() {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const nav = useNavigate();
  const load = () => api.get("/admin/templates").then((r) => setItems(r.data));
  useEffect(() => { if (open) load(); }, [open]);
  const rename = async (t) => {
    const name = window.prompt("Novo nome do template:", t.name);
    if (!name || name.trim() === t.name) return;
    try { await api.patch(`/admin/templates/${t.id}`, { name }); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  const del = async (t) => { if (window.confirm(`Eliminar o template "${t.name}"? Os relógios já criados não são afetados.`)) { await api.delete(`/admin/templates/${t.id}`); load(); } };
  return (
    <>
      <button type="button" className="btn-line !py-2.5" onClick={() => setOpen(true)} data-testid="admin-templates-button"><LayoutTemplate className="w-4 h-4" /> Novo a partir de template</button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#12110E] border-[#282520] max-w-2xl" data-testid="admin-templates-dialog">
          <DialogHeader><DialogTitle>Templates de relógios</DialogTitle></DialogHeader>
          {!items.length && <p className="text-sm text-[#A39E93]" data-testid="admin-templates-empty">Ainda não há templates. Abra um relógio e use "Guardar como template".</p>}
          <ul className="divide-y divide-[#282520] max-h-[60vh] overflow-y-auto">
            {items.map((t) => (
              <li key={t.id} className="py-3 flex items-center gap-3" data-testid={`admin-template-${t.id}`}>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-[#F3EFE6] truncate">{t.name}</p>
                  <p className="text-xs text-[#A39E93] truncate">{t.brand} {t.model} {t.reference} {t.dial ? `· ${t.dial}` : ""} {t.strap ? `· ${t.strap}` : ""}</p>
                </div>
                <button type="button" className="btn-gold !py-1.5 !px-3 text-xs" onClick={() => nav(`/admin/relogios/novo?template=${t.id}`)} data-testid={`admin-template-use-${t.id}`}>Usar</button>
                <button type="button" className="btn-line !py-1.5 !px-2" title="Renomear" onClick={() => rename(t)} data-testid={`admin-template-rename-${t.id}`}><Pencil className="w-3.5 h-3.5" /></button>
                <button type="button" className="btn-line !py-1.5 !px-2" title="Eliminar" onClick={() => del(t)} data-testid={`admin-template-delete-${t.id}`}><Trash2 className="w-3.5 h-3.5" /></button>
              </li>
            ))}
          </ul>
        </DialogContent>
      </Dialog>
    </>
  );
}

export function WatchCopyActions({ w }) {
  const nav = useNavigate();
  const saveTpl = async () => {
    const name = window.prompt("Nome do template:", `${w.brand} ${w.model}`);
    if (!name) return;
    try { await api.post(`/admin/watches/${w.id}/template`, { name }); toast.success("Template guardado"); } catch (e) { toast.error(errMsg(e)); }
  };
  const dup = async () => {
    if (!window.confirm("Criar uma cópia deste relógio como rascunho (sem fotos, stock 0)?")) return;
    try { const r = await api.post(`/admin/watches/${w.id}/duplicate`); toast.success("Cópia criada. Altere fotos, referência, cor…"); nav(`/admin/relogios/${r.data.id}`); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <>
      <button type="button" onClick={saveTpl} className="btn-line !py-2.5" data-testid="admin-watch-save-template"><BookmarkPlus className="w-4 h-4" /> Guardar como template</button>
      <button type="button" onClick={dup} className="btn-line !py-2.5" data-testid="admin-watch-duplicate"><Copy className="w-4 h-4" /> Duplicar</button>
    </>
  );
}
